import React from "react";

import AppleLogo from "assets/Apple-logo.svg";
import GoogleLogo from "assets/Google-logo.svg";
import { StyledGrid } from "components/simple";
import { spacingDefaults } from "style/constants";
import BGCStoreLinkButton from "./BGCStoreLinkButton";

const StoreLinks: React.FC = () => (
  <StyledGrid
    container
    direction="column"
    alignItems="center"
    style={{ gap: spacingDefaults.small }}
  >
    <BGCStoreLinkButton
      href={process.env.REACT_APP_BGC_IOS_LINK || ""}
      label="Open in iOS"
      logo={AppleLogo}
      logoAlt="Apple logo"
      logoSize={30}
    />
    <BGCStoreLinkButton
      href={process.env.REACT_APP_BGC_ANDROID_LINK || ""}
      label="Open in Google"
      logo={GoogleLogo}
      logoAlt="Google logo"
      logoSize={20}
    />
  </StyledGrid>
);

export default StoreLinks;
